import ApiService from "./api.service";

const PointsPerTyresService = {
  async list() {
    try {
      const response = await ApiService.get("points-per-tyres");
      if (response.status === 200) {
        return response.data;
      }
      return null;
    } catch (error) {
      return error.response || null;
    }
  },
};

export { PointsPerTyresService };
